/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * BETREIBER 13.09.2026: „Es muss heissen Blockgroesse. Drei
 * Einstellungen: «Vollflaechig» nimmt den ganzen Block ein, keine
 * abgerundeten Ecken. «Button» entspricht einer Abdeckung von 95 %,
 * wenig Platz oben, unten und an den Seiten, sowie abgerundete Ecken.
 * «Fest» mit fester Breite und Hoehe gemaess den Standardeinstellungen
 * des Buttons."
 * 
 *   VOLLFLAECHIG — 100 % x 100 %, keine Rundung.
 *   BUTTON       — 5 % Abstand an JEDER Seite (oben, unten, links,
 *                  rechts), Rundung wie die Knoepfe der Datenbank
 *                  (`--db-cta-border-radius`). Praezisiert vom Betreiber
 *                  am 14.09.2026: „95 % bedeutet oben unten rechts und
 *                  links 5 % im Verhaeltnis zum Gesamtplatz des
 *                  Bausteines Platz." Vorher waren es 95 % Breite mit
 *                  `margin: auto` — also nur 2,5 % je Seite.
 *   FEST         — Hoehe der Art (72 bzw. 34 px), Breite nur so breit
 *                  wie der Inhalt, Rundung wie die Knoepfe.
 * 
 * ERSETZT `DatabaseBannerHoehe` (FEST | ANGEPASST). Das alte Feld bleibt
 * im Schema lesbar — ein Baustein, der es traegt, wird sonst nicht mehr
 * gelesen ([[reference_enum_wert_nie_loeschen]]); ANGEPASST gilt dann
 * als VOLLFLAECHIG.
 * @export
 */
export const DatabaseBannerBlockGroesse = {
    Vollflaechig: 'VOLLFLAECHIG',
    Button: 'BUTTON',
    Fest: 'FEST'
} as const;
export type DatabaseBannerBlockGroesse = typeof DatabaseBannerBlockGroesse[keyof typeof DatabaseBannerBlockGroesse];


export function DatabaseBannerBlockGroesseFromJSON(json: any): DatabaseBannerBlockGroesse {
    return DatabaseBannerBlockGroesseFromJSONTyped(json, false);
}

export function DatabaseBannerBlockGroesseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerBlockGroesse {
    return json as DatabaseBannerBlockGroesse;
}

export function DatabaseBannerBlockGroesseToJSON(value?: DatabaseBannerBlockGroesse | null): any {
    return value as any;
}

